import React from 'react';

const InvalidPage = () => {
    return (
        <div
            className={`w-screen h-screen bg-[#0A0813E3] flex items-center justify-center absolute transition-opacity duration-200"opacity-100 scale-100
                `}
        >
            <div
                className={`bg-white absolute rounded-[24px] shadow-md p-8 w-[311px] h-[353px] xl:h-[260px] xl:w-[403px] flex flex-col gap-4 items-center justify-center text-center xl:p-10 xl:gap-4 transition-transform duration-400`}
            >
                <img src="/images/error.png" className="w-[36px]" alt="" />
                <h2 className="font-bold text-[20px] leading-[122%] tracking-[0%] text-center   xl:text-[20px] 2xl:text-[22px] xxl:text-2xl xl:leading-none text-[#5D0E23] xl:tracking-normal">
                Invalid Or Expired Link
                </h2>
                <p className="font-medium text-[12px] leading-none tracking-[0%] text-center   xl:text-[12px] 2xl:text-[14px] xxl:text-base xl:leading-none xl:tracking-normal text-[#636D80]">
                The link you have followed is either invalid or has expired. Please Check the link or contact support for assistance.
                </p>
            </div>
        </div>
    );
};

export default InvalidPage;